import axios from 'axios';

import { getLoggerService } from '@/modules/logger/infrastructure/loggerService';
import { getRegionFromHostname } from '@/modules/region/domain/hostname-resolver';
import URLS from '@/services/urls';

import { SET_CURRENT_DOMAIN_PREFIX, SET_DETECTED_COUNTRY, SET_PAYMENT_DETECTED_COUNTRY } from '../mutation-types';

/**
 * Fetch detected country from cloudflare quic service
 * @param {function} commit - The vuex commit function
 * @param {String} payload - Manuel value
 * @return {undefined}
 */
export async function fetchDetectedCountryAction({ commit }, payload = null) {
  try {
    let selectedCountry = payload;

    if (!selectedCountry) {
      const { data } = await axios.get(URLS.CLOUDFLARE_QUIC_ALTERNATIVE);
      const [, countryCodePart] = data.split('loc=');
      const [country] = countryCodePart.split('\n');
      getLoggerService().logger.info('Detected country by Cloudflare', { country });
      selectedCountry = country;
    }

    commit(SET_DETECTED_COUNTRY, selectedCountry);
    commit(`payment/${SET_PAYMENT_DETECTED_COUNTRY}`, selectedCountry, { root: true });
  } catch (error) {
    getLoggerService().logger.error('fetchDetectedCountry error', { error });
    commit(SET_DETECTED_COUNTRY, 'US');
    commit(`payment/${SET_PAYMENT_DETECTED_COUNTRY}`, 'US', { root: true });
  }
}

/**
 * Set current domain prefix from url
 * @param {function} commit - The vuex commit function
 * @return {String} Should be UK || EU || US
 */
export function setCurrentDomainPrefix({ commit }) {
  const countryCode = getRegionFromHostname(window.location.hostname);
  commit(SET_CURRENT_DOMAIN_PREFIX, countryCode);
}
